const regularScopes = [
  'openid',
  'profile',
  'User.Read',
  'Mail.Read',
  'Mail.ReadBasic',
  'Mail.ReadWrite',
];
const sharedMailboxScopes = ['Mail.Read.Shared', 'Mail.ReadBasic.Shared', 'Mail.ReadWrite.Shared'];

// https://github.com/OfficeDev/office-js/issues/4622
// https://github.com/OfficeDev/office-js/issues/4767
// Currently NAA fails with shared mailbox scopes, so we need to exclude them
// Note: Per Microsoft docs, the token request must include scopes other than just
// 'offline_access', 'openid', 'profile', or 'email'. At minimum, we include 'User.Read'.
// https://learn.microsoft.com/en-us/office/dev/add-ins/develop/enable-nested-app-authentication-in-your-add-in?tabs=outlook
export const getAuthenticationScopes = (includeSharedMailboxScopes = false) =>
  includeSharedMailboxScopes ? [...regularScopes, ...sharedMailboxScopes] : regularScopes;
